import { useGetList, type Identifier } from "ra-core";
import { RelatedTasks } from "./RelatedTasks";

/**
 * The contact page's tasks: the contact's own, those of its deals (deals.contact_ids contains it)
 * and those of its compagnie.
 */
export const ContactRelatedTasks = ({
  contactId,
  companyId,
}: {
  contactId: Identifier;
  companyId?: Identifier | null;
}) => {
  const { data: deals, isPending } = useGetList<{ id: Identifier }>("deals", {
    filter: { "contact_ids@cs": `{${contactId}}` },
    sort: { field: "id", order: "ASC" },
    pagination: { page: 1, perPage: 1000 },
  });
  if (isPending) return null;
  return (
    <RelatedTasks
      dealIds={(deals ?? []).map((d) => d.id)}
      contactIds={[contactId]}
      companyId={companyId ?? null}
    />
  );
};
